import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import { TESTIMONIALS } from "../data/content";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const Testimonials = () => (
    <section data-testid="testimonials-section" className="relative py-20 sm:py-28 bg-slate-50/70 dark:bg-slate-950/60 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center max-w-2xl mx-auto mb-12">
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">Testimonials</div>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
                    Loved by <span className="text-gradient-brand">Healthcare Pros</span>
                </h2>
            </motion.div>

            <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={24}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000 }}
                breakpoints={{ 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
                className="!pb-14"
            >
                {TESTIMONIALS.map((t, i) => (
                    <SwiperSlide key={t.name}>
                        <div data-testid={`testimonial-${i}`} className="h-full p-7 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm flex flex-col">
                            <FaQuoteLeft className="text-brand-300 dark:text-brand-700 text-2xl" />
                            <p className="mt-4 text-slate-700 dark:text-slate-300 leading-relaxed flex-1">"{t.text}"</p>
                            <div className="flex mt-4 gap-1">
                                {[...Array(5)].map((_, j) => <FaStar key={j} className="text-amber-400 text-sm" />)}
                            </div>
                            <div className="mt-5 flex items-center gap-3 pt-5 border-t border-slate-100 dark:border-slate-800">
                                <div>
                                    <div className="font-heading font-semibold text-slate-900 dark:text-white text-sm">{t.name}</div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    </section>
);

export default Testimonials;
